import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import App from "./App";
import store from "./store/store";
import "./index.css";
import AppThemeProvider from "./ThemeProvider";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PKEY!, {});

root.render(
  <React.StrictMode>
    <AppThemeProvider>
      <Provider store={store}>
        <Elements stripe={stripePromise}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Elements>
      </Provider>
    </AppThemeProvider>
  </React.StrictMode>,
);
